var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1002,
    height: 710,
    viewBox: "0 0 1002 710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1001.13 127.078C1000.34 101.917 993.893 78.4169 982.332 58.5914C970.771 38.7659 954.443 23.2059 934.746 13.2445C915.05 3.28317 892.572 -0.782702 869.238 1.39526C845.905 3.57322 822.411 11.9301 800.77 25.7499L49.7284 530.564C33.1862 542.677 19.6316 559.56 10.942 578.874C2.25261 598.189 -1.14176 618.979 1.22906 638.365C3.59988 657.752 11.6186 674.775 24.1746 687.078C36.7306 699.38 53.2027 706.353 71.3092 707.03C72.6164 706.752 533.865 708.393 534.27 708.416L994.804 709.666L1001.13 127.078Z",
    fill: "url(#paint0_radial_7_3623)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_3623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.846 464.743) rotate(170.33) scale(529.292 377.056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47A432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A432",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector-1.f83dafa4f84d685a7e0f004b62fa628c.svg";
export { ForwardRef as ReactComponent };